import { Stack, Typography } from '@mui/material'
import ProfilePic from '../../../../assets/images/avatar.png'
import { InvoiceResponse } from '../../../../store/invoices/invoices.types'

const InvoiceEditViewFrom = ({ customerName }: Partial<InvoiceResponse>) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <img src={ProfilePic} width={40} height={40} alt="profile pic" />
      <Stack>
        <Typography fontWeight={700} textAlign="right">
          {customerName}
        </Typography>
        {/* <Typography fontWeight={300} textAlign="right">
          {'email'}
        </Typography> */}
      </Stack>
    </Stack>
  )
}

export default InvoiceEditViewFrom
